import { useLenis } from "lenis/react";
import { useCallback } from "react";

export function useSmoothScroll() {
  const lenis = useLenis();
  return useCallback(
    (href, focusSelector) => {
      const el = document.querySelector(href);
      if (!el) return;
      const near = Math.abs(el.getBoundingClientRect().top) < window.innerHeight * 0.5;
      if (lenis) {
        lenis.scrollTo(el, { offset: -64, duration: 1.4 });
      } else {
        el.scrollIntoView({ behavior: "smooth" });
      }
      if (focusSelector) {
        setTimeout(() => {
          document.querySelector(focusSelector)?.focus({ preventScroll: true });
        }, near ? 250 : 1450);
      }
    },
    [lenis]
  );
}
